var PlacementParts;
(function (PlacementParts) {
    PlacementParts["top"] = "top";
    PlacementParts["bottom"] = "bottom";
    PlacementParts["start"] = "start";
    PlacementParts["end"] = "end";
    PlacementParts["left"] = "left";
    PlacementParts["right"] = "right";
    PlacementParts["center"] = "";
})(PlacementParts || (PlacementParts = {}));
var positionMap = new Map([
    ['above', function () { return PlacementParts.top; }],
    ['below', function () { return PlacementParts.bottom; }],
    ['before', function (rtl) { return (rtl ? PlacementParts.right : PlacementParts.left); }],
    ['after', function (rtl) { return (rtl ? PlacementParts.left : PlacementParts.right); }],
]);
var alignmentMap = new Map([
    ['start', function (rtl) { return (rtl ? PlacementParts.end : PlacementParts.start); }],
    ['end', function (rtl) { return (rtl ? PlacementParts.start : PlacementParts.end); }],
    ['top', function () { return PlacementParts.start; }],
    ['bottom', function () { return PlacementParts.end; }],
    ['center', function () { return PlacementParts.center; }],
]);
var shouldAlignToCenter = function (p, a) {
    var positionedVertically = p === 'above' || p === 'below';
    var alignedVertically = a === 'top' || a === 'bottom';
    return ((positionedVertically && alignedVertically) || (!positionedVertically && !alignedVertically));
};
/**
 * | position | alignment | placement       | placement RTL
 * -----------------------------------------------------------------
 * | above    | start     |  top-start      |  top-end
 * | above    | center    |  top            |  top
 * | above    | end       |  top-end        |  top-start
 * | below    | start     |  bottom-start   |  bottom-end
 * | below    | center    |  bottom         |  bottom
 * | below    | end       |  bottom-end     |  bottom-start
 * | before   | top       |  left-start     |  right-start
 * | before   | center    |  left           |  right
 * | before   | bottom    |  left-end       |  right-end
 * | after    | top       |  right-start    |  left-start
 * | after    | center    |  right          |  left
 * | after    | bottom    |  right-end      |  left-end
 */
export var getPopupPlacement = function (_a) {
    var align = _a.align, position = _a.position, rtl = _a.rtl;
    var alignment = shouldAlignToCenter(position, align) ? 'center' : align;
    var computedPosition = positionMap.get(position)(rtl);
    var computedAlignmnent = alignmentMap.get(alignment)(rtl);
    var stringifiedAlignment = computedAlignmnent && "-" + computedAlignmnent;
    return "" + computedPosition + stringifiedAlignment;
};
/////////////////////////////////
// OFFSET VALUES ADJUSTMENT
/////////////////////////////////
var flipPlusMinusSigns = function (offset) {
    return offset
        .replace(/\-/g, '<plus>')
        .replace(/^(\s*)(?=\d)/, '<minus>')
        .replace(/\+/g, '<minus>')
        .replace(/<plus>/g, '+')
        .replace(/<minus>/g, '-')
        .trimLeft()
        .replace(/^\+/, '');
};
export var applyRtlToOffset = function (offset, position) {
    if (position === 'above' || position === 'below') {
        var _a = offset.split(','), horizontal = _a[0], vertical = _a[1];
        return [flipPlusMinusSigns(horizontal), vertical]
            .join(', ')
            .replace(/, $/, '')
            .trim();
    }
    return offset;
};
